import logo from './logo.svg'

export const Footer: React.FC = () => {
  const now = new Date()

  return (
    <footer className="border-t border-gray/30 py-10 px-5">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <img src={logo} alt="FLOWER" className="h-6" />
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] text-dark-gray">
          <a href="/commercial" className="hover:text-main transition-colors">
            特定商取引法に基づく表記
          </a>
          <a href="/policy" className="hover:text-main transition-colors">
            プライバシーポリシー
          </a>
          <a href="/terms" className="hover:text-main transition-colors">
            利用規約
          </a>
          <a href="/faq" className="hover:text-main transition-colors">
            お問い合わせ
          </a>
        </nav>
      </div>
      <p className="mt-6 text-center text-[10px] text-dark-gray/60">© {now.getFullYear()} FLOWER Inc.</p>
    </footer>
  )
}
